module.exports = __webpack_public_path__ + "static/media/export.41b15d26.svg";